export const stats = [
  { value: "10,000+", label: "Verified Product Listings" },
  { value: "500+", label: "Trusted Seller Recommendations" },
  { value: "98%", label: "Buyer Satisfaction Rate" },
  { value: "Weekly", label: "Spreadsheet Updates" },
];

export const trustItems = [
  {
    icon: "ri-shield-check-line",
    title: "Verified Sellers",
    description: "Every seller in our spreadsheet undergoes a rigorous verification process. We check transaction history, buyer feedback, and product authenticity before adding any recommendation."
  },
  {
    icon: "ri-refresh-line",
    title: "Updated Weekly",
    description: "Our Kakobuy spreadsheet is refreshed every week with new finds, updated prices, and the latest seller reliability scores to keep you ahead of the trends."
  },
  {
    icon: "ri-guide-line",
    title: "Complete Buying Guides",
    description: "From size conversion charts to shipping tips and quality inspection checklists, we provide everything you need for a safe and successful purchase."
  },
  {
    icon: "ri-shield-star-line",
    title: "Scam Prevention",
    description: "Learn how to spot counterfeit products, avoid unreliable sellers, and protect your payment with our comprehensive safety guides and red-flag checklists."
  },
];